<template>
    <div class="storefront-heading-container flex h-80 lg:mb-0 mb-4">
        <div class="w-full invisible sm:visible h-3/5 bg-salesium-blue">
            <img
                v-show="!showDefaultBanner"
                @load="showDefaultBanner = false"
                class="w-full object-contain h-full m-auto"
                :src="user.storefront_banner_uri"
            />
            <img
                v-show="showDefaultBanner"
                class="w-full object-contain h-full m-auto"
                :src="this.defaultBanner()"
            />

            <a
                class="flex justify-end mt-4"
                title="Storefront"
                @click="showUploadModal('banner')"
                v-if="isOwnStorefront"
            >
                <svg-vue
                    icon="pencil-solid"
                    title="storefront icon"
                    class="w-6 h-6 fill-black"
                />
            </a>
        </div>
        <div
            class="absolute top-[12%] left-10 sm:-translate-x-1/2 sm:top-[15%] sm:left-[12%] h-32 w-32 md:w-40 md:h-40 md:transform-none"
        >
            <img
                v-show="!showingDefaultAvatar"
                @load="showingDefaultAvatar = false"
                :src="user.avatar_uri"
                alt="User Profile Picture"
                class="w-32 h-32 md:w-40 md:h-40 rounded-full outline:nonedefault-avatar-icon"
                :class="
                    user.type == 'pro'
                        ? user.care_score > 3
                            ? user.care_score >= 4
                                ? 'badgeBlue'
                                : 'badgeGreen'
                            : ''
                        : ''
                "
            />
            <div class="rounded-full bg-white" v-show="showingDefaultAvatar">
                <svg-vue
                    icon="circle-user"
                    title="default user avatar"
                    class="h-32 w-32 md:w-40 md:h-40"
                    :class="
                        user.type == 'pro'
                            ? user.care_score > 3
                                ? user.care_score >= 4
                                    ? 'fill-salesium-blue'
                                    : 'fill-salesium-green'
                                : ''
                            : ''
                    "
                />
            </div>

            <a
                class="flex ml-20 translate-x-1/2 -translate-y-2"
                title="Storefront"
                @click="showUploadModal('avatar')"
                v-if="isOwnStorefront"
            >
                <svg-vue
                    icon="pencil-solid"
                    title="storefront icon"
                    class="w-6 h-6 fill-black"
                />
            </a>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showingDefaultAvatar: true,
            showDefaultBanner: true,
        };
    },
    props: ["user", "isOwnStorefront"],
    methods: {
        showUploadModal(uploadType) {
            if (this.isOwnStorefront) {
                this.$emit("showUploadModal", uploadType);
            }
        },
        defaultBanner() {
            if( this.user.industry !== null)
                return '/img/defaultBanners/' + this.user.industry.name + '.png';
            return '/img/defaultBanners/General.png';
        }
    },
};
</script>
